// Google Consent Mode integration helpers
// Docs: https://developers.google.com/tag-platform/devguides/consent

// Categories (aligned with CookieConsent configuration in CookieBanner)
export const CAT_NECESSARY = "necessary";
export const CAT_ANALYTICS = "analytics";
export const CAT_MARKETING = "marketing"; // using existing app wording instead of "advertisement" to match i18n
export const CAT_FUNCTIONALITY = "functionality";

// Google Consent Mode services
export const SERVICE_AD_STORAGE = "ad_storage" as const;
export const SERVICE_AD_USER_DATA = "ad_user_data" as const;
export const SERVICE_AD_PERSONALIZATION = "ad_personalization" as const;
export const SERVICE_ANALYTICS_STORAGE = "analytics_storage" as const;
export const SERVICE_FUNCTIONALITY_STORAGE = "functionality_storage" as const;
export const SERVICE_PERSONALIZATION_STORAGE = "personalization_storage" as const;
export const SERVICE_SECURITY_STORAGE = "security_storage" as const;

function gtag(...args: unknown[]) {
  const dataLayer = (window as { dataLayer?: unknown[] }).dataLayer || [];
  dataLayer.push(args);
}

/**
 * Update Google Consent Mode based on current selections in CookieConsent.
 * This expects CookieConsent.run to be initialized and will read accepted services from it.
 */

export function updateGtagConsentFromCookieConsent(CookieConsent: {
  acceptedService: (service: string, category: string) => boolean;
  acceptedCategory: (category: string) => boolean;
}) {
  gtag("consent", "update", {
    [SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS)
      ? "granted"
      : "denied",
    [SERVICE_AD_STORAGE]: CookieConsent.acceptedService(SERVICE_AD_STORAGE, CAT_MARKETING) ? "granted" : "denied",
    [SERVICE_AD_USER_DATA]: CookieConsent.acceptedService(SERVICE_AD_USER_DATA, CAT_MARKETING) ? "granted" : "denied",
    [SERVICE_AD_PERSONALIZATION]: CookieConsent.acceptedService(SERVICE_AD_PERSONALIZATION, CAT_MARKETING)
      ? "granted"
      : "denied",
    [SERVICE_FUNCTIONALITY_STORAGE]: CookieConsent.acceptedCategory(CAT_FUNCTIONALITY) ? "granted" : "denied",
    [SERVICE_PERSONALIZATION_STORAGE]: "denied",
    [SERVICE_SECURITY_STORAGE]: CookieConsent.acceptedCategory(CAT_NECESSARY) ? "granted" : "denied",
  });
}
